import CreateNewMiniBot from './CreateNewMiniBot';
export default CreateNewMiniBot;
